/*
 * Public API Surface of sdk-loading
 */

export { SDKLoadingModule } from './lib/sdk-loading.module';
export { SDKLoadingComponent } from './lib/sdk-loading.component';
